/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
import type { RmCalculationType } from './RmCalculationType';
import {
    RmCalculationTypeFromJSON,
    RmCalculationTypeFromJSONTyped,
    RmCalculationTypeToJSON,
    RmCalculationTypeToJSONTyped,
} from './RmCalculationType';
import type { CalculationType } from './CalculationType';
import {
    CalculationTypeFromJSON,
    CalculationTypeFromJSONTyped,
    CalculationTypeToJSON,
    CalculationTypeToJSONTyped,
} from './CalculationType';
import type { RrpCalculationType } from './RrpCalculationType';
import {
    RrpCalculationTypeFromJSON,
    RrpCalculationTypeFromJSONTyped,
    RrpCalculationTypeToJSON,
    RrpCalculationTypeToJSONTyped,
} from './RrpCalculationType';
import type { PriceUnitDto } from './PriceUnitDto';
import {
    PriceUnitDtoFromJSON,
    PriceUnitDtoFromJSONTyped,
    PriceUnitDtoToJSON,
    PriceUnitDtoToJSONTyped,
} from './PriceUnitDto';

/**
 * 
 * @export
 * @interface CalculationSettingsDto
 */
export interface CalculationSettingsDto {
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    year: number;
    /**
     * 
     * @type {PriceUnitDto}
     * @memberof CalculationSettingsDto
     */
    priceUnit: PriceUnitDto;
    /**
     * 
     * @type {CalculationType}
     * @memberof CalculationSettingsDto
     */
    calculationType?: CalculationType;
    /**
     * 
     * @type {RmCalculationType}
     * @memberof CalculationSettingsDto
     */
    rmCalculationType?: RmCalculationType;
    /**
     * 
     * @type {RrpCalculationType}
     * @memberof CalculationSettingsDto
     */
    rrpCalculationType?: RrpCalculationType;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    fmcTarget: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    targetLpIndex: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    targetRrpIndex?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    breakEvenFactor?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    priceThreshold: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    aboveThresholdMin: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    aboveThresholdMax: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    belowThresholdMin: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsDto
     */
    belowThresholdMax: number;
    /**
     * 
     * @type {PriceUnitDto}
     * @memberof CalculationSettingsDto
     */
    calculationBasisPriceUnit?: PriceUnitDto;
    /**
     * 
     * @type {boolean}
     * @memberof CalculationSettingsDto
     */
    enableAutoCalc: boolean;
}



/**
 * Check if a given object implements the CalculationSettingsDto interface.
 */
export function instanceOfCalculationSettingsDto(value: object): value is CalculationSettingsDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('year' in value) || value['year'] === undefined) return false;
    if (!('priceUnit' in value) || value['priceUnit'] === undefined) return false;
    if (!('fmcTarget' in value) || value['fmcTarget'] === undefined) return false;
    if (!('targetLpIndex' in value) || value['targetLpIndex'] === undefined) return false;
    if (!('priceThreshold' in value) || value['priceThreshold'] === undefined) return false;
    if (!('aboveThresholdMin' in value) || value['aboveThresholdMin'] === undefined) return false;
    if (!('aboveThresholdMax' in value) || value['aboveThresholdMax'] === undefined) return false;
    if (!('belowThresholdMin' in value) || value['belowThresholdMin'] === undefined) return false;
    if (!('belowThresholdMax' in value) || value['belowThresholdMax'] === undefined) return false;
    if (!('enableAutoCalc' in value) || value['enableAutoCalc'] === undefined) return false;
    return true;
}

export function CalculationSettingsDtoFromJSON(json: any): CalculationSettingsDto {
    return CalculationSettingsDtoFromJSONTyped(json, false);
}

export function CalculationSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationSettingsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'year': json['year'],
        'priceUnit': PriceUnitDtoFromJSON(json['priceUnit']),
        'calculationType': json['calculationType'] == null ? undefined : CalculationTypeFromJSON(json['calculationType']),
        'rmCalculationType': json['rmCalculationType'] == null ? undefined : RmCalculationTypeFromJSON(json['rmCalculationType']),
        'rrpCalculationType': json['rrpCalculationType'] == null ? undefined : RrpCalculationTypeFromJSON(json['rrpCalculationType']),
        'fmcTarget': json['fmcTarget'],
        'targetLpIndex': json['targetLpIndex'],
        'targetRrpIndex': json['targetRrpIndex'] == null ? undefined : json['targetRrpIndex'],
        'breakEvenFactor': json['breakEvenFactor'] == null ? undefined : json['breakEvenFactor'],
        'priceThreshold': json['priceThreshold'],
        'aboveThresholdMin': json['aboveThresholdMin'],
        'aboveThresholdMax': json['aboveThresholdMax'],
        'belowThresholdMin': json['belowThresholdMin'],
        'belowThresholdMax': json['belowThresholdMax'],
        'calculationBasisPriceUnit': json['calculationBasisPriceUnit'] == null ? undefined : PriceUnitDtoFromJSON(json['calculationBasisPriceUnit']),
        'enableAutoCalc': json['enableAutoCalc'],
    };
}

export function CalculationSettingsDtoToJSON(json: any): CalculationSettingsDto {
    return CalculationSettingsDtoToJSONTyped(json, false);
}

export function CalculationSettingsDtoToJSONTyped(value?: CalculationSettingsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'year': value['year'],
        'priceUnit': PriceUnitDtoToJSON(value['priceUnit']),
        'calculationType': CalculationTypeToJSON(value['calculationType']),
        'rmCalculationType': RmCalculationTypeToJSON(value['rmCalculationType']),
        'rrpCalculationType': RrpCalculationTypeToJSON(value['rrpCalculationType']),
        'fmcTarget': value['fmcTarget'],
        'targetLpIndex': value['targetLpIndex'],
        'targetRrpIndex': value['targetRrpIndex'],
        'breakEvenFactor': value['breakEvenFactor'],
        'priceThreshold': value['priceThreshold'],
        'aboveThresholdMin': value['aboveThresholdMin'],
        'aboveThresholdMax': value['aboveThresholdMax'],
        'belowThresholdMin': value['belowThresholdMin'],
        'belowThresholdMax': value['belowThresholdMax'],
        'calculationBasisPriceUnit': PriceUnitDtoToJSON(value['calculationBasisPriceUnit']),
        'enableAutoCalc': value['enableAutoCalc'],
    };
}

